import { createContext } from "react";

import { IRemoteDataContext, IViewApiKeys } from "../interfaces-and-types";

export const ApiKeysContext = createContext<
  IRemoteDataContext<IViewApiKeys | null>
>({
  // remote data
  isSuccess: false,
  isError: false,
  isLoading: false,
  data: null,
  refreshRemoteData: () => {},
});
